import React from 'react'
import img1 from "../stock/IEEE2022A.jpg"
import img2 from "../stock/IEEE2022B.jpg"

const IEEE2022 = () => {
  return (
    <>
        <p style={{fontSize: "40px",fontWeight: "500", textAlign: "center",marginTop: "20px"}}>IEEE DAY 2022</p>
        <div className="events-section" style={{display: "flex",justifyContent: "center",flexWrap: "wrap"}}>
            <div style={{ backgroundColor: 'white', borderRadius: '6px', width: '700px', display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: "90%" }}>
                <img src={img1} style={{ margin: '20px auto', borderRadius: '6px', maxWidth: '95%' }} alt="Your Image" />
            </div>
        </div>
        <div className="events-section" style={{display: "flex",justifyContent: "center",flexWrap: "wrap"}}>
            <div style={{ backgroundColor: 'white', borderRadius: '6px', width: '700px', display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: "90%" }}>
                <img src={img2} style={{ margin: '20px auto', borderRadius: '6px', maxWidth: '95%' }} alt="Your Image" />
            </div>
        </div>
    </>
  )
}

export default IEEE2022